module.exports = __webpack_public_path__ + "img/canada-respiratory-diseases-female.d0a8b0b7.png";